import React from 'react';

const LiveHoleWeather = ({ weather }) => {
    if (!weather ||
        !weather.windSpeed ||
        !weather.windDirection ||
        !weather.temperature
    ) {
        return null;
    }

    let windDirectionClassName = '';

    if (weather.windDirection) {
        windDirectionClassName = `is-${weather.windDirection.toLowerCase()}`;
    }

    return (
        <div className={`live-hole-weather ${windDirectionClassName}`}>
            <div className="live-hole-weather__container">
                <div className="live-hole-weather__speed">
                    <div className="live-hole-weather__speed-container">
                        <div className="live-hole-weather__speed-text">{weather.windSpeed}</div>
                        <svg
                            className="live-hole-weather__speed-icon"
                            xmlns="http://www.w3.org/2000/svg"
                            width="38"
                            height="36"
                            viewBox="0 0 38 36"
                        >
                            <g fill="none" fillRule="evenodd" transform="translate(-5 -6)">
                                <circle
                                    cx="26.906" cy="25.594" r="15.094" fillRule="nonzero" stroke="#FFF"
                                    strokeWidth="2" />
                                <g stroke="#FFF" strokeWidth="2">
                                    <path d="M6.813 8.118l8.09 7.284M6.386 14.418l.31-6.444 6.392-1" />
                                </g>
                            </g>
                        </svg>
                    </div>
                </div>
                <div className="live-hole-weather__content">
                    <div className="live-hole-weather__direction">{weather.windDirection}</div>
                    <div className="live-hole-weather__temperature">{weather.temperature}</div>
                </div>
            </div>
        </div>
    );
};

export default LiveHoleWeather;
